import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { get, map } from 'lodash';
import {
  FontIcon,
  RaisedButton,
} from 'material-ui';

import styles from 'styles/TransportationGrant';
import dateFormat from 'utils/dateTools';
import KTitle from '../../components/KJRN/KTitle';
import TMessage from '../../containers/tiles/TMessage';
import { STATE_PROPS, ICONS } from './constants';

const FrontCard = ({
  embed, grant, loading, handleClick,
}) => {
  const { Previous } = grant;

  return (
    <div>
      <div style={embed ? styles.embedCard : styles.card}>
        <KTitle
          style={{
            margin: 0,
            marginBottom: 12,
            fontWeight: 600,
            fontSize: 20,
          }}
          title={grant.HrTransportationGrantName}
        />
        <div style={styles.htmlContainer} dangerouslySetInnerHTML={{ __html: get(grant, 'EmailTemplate.TextBody') }} />
        {Previous && Previous.length && !loading
          ? (
            <TMessage style={styles.message} type="success" message="transportationGrant.active">
              {map(Previous, prev => (
                <div key={prev.EmployeeMasterTransportationID} style={styles.dateRange}>
                  {`${dateFormat(prev.Begda)} - ${dateFormat(prev.Endda)}`}
                  {map(STATE_PROPS, prop => (get(prev, prop)
                    ? <FontIcon key={prop} style={styles.iconActivity} className="material-icons">{get(ICONS, prop)}</FontIcon>
                    : null
                  ))}
                </div>
              ))}
            </TMessage>
          )
          : null
        }
        <RaisedButton
          data-cy={`register-${grant.HrTransportationGrantName}`}
          primary
          style={styles.button}
          label={<FormattedMessage id="transportationGrant.register" />}
          onClick={handleClick(true)}
        />
      </div>
    </div>
  );
};

FrontCard.propTypes = {
  loading: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  embed: PropTypes.bool,
  grant: PropTypes.shape({
    HrTransportationGrantID: PropTypes.number.isRequired,
    HrTransportationGrantName: PropTypes.string.isRequired,
    PublicTransportation: PropTypes.string,
    Cycling: PropTypes.string,
    Walking: PropTypes.string,
    TransportationCard: PropTypes.string,
    Months: PropTypes.number,
    AmountPerMonth: PropTypes.string,
    Previous: PropTypes.arrayOf(PropTypes.shape({
      Begda: PropTypes.string,
      Endda: PropTypes.string,
    })),
  }).isRequired,
};

FrontCard.defaultProps = {
  loading: false,
  embed: false,
};

export default FrontCard;



// WEBPACK FOOTER //
// ./src/sites/transportationGrants/FrontCard.js